
/**
 * Abstraction of map 2D point
 */
export class Point {

    /**
     * Latitude
     */
    public lat: number;

    /**
     * Longtitude
     */
    public lng: number;

    /**
     * A value that uniquely identifies this point
     */
    public id?: string | number;

    /**
     * Object for currying properties necessary after clustering
     */
    public properties?: any

    /**
     * Construktor of Point
     * @param lat latitude
     * @param lng longitude
     */
    public constructor(lat: number = 0, lng: number = 0) {
        this.lat = lat;
        this.lng = lng;
    }

}